import { useState } from 'react';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Input from '@/components/Inputs/Input';
import { useModalContext } from '@/components/Modal/Modal';
import Typo from '@/components/Typography/Typo';
import { Button } from '@/shared/ui/button';
import { modalStyle } from '@/styles/style';

type Props = {
  onConfirm: (dashboardName: string) => void;
  value?: string;
  title?: string;
  label?: string;
  buttonLabel?: string;
  folderAlias?: string;
};

const DashboardModal = (props: Props) => {
  const { closeModal } = useModalContext();
  const [dashboardName, setDashboardName] = useState<string>(props.value || '');

  return (
    <StyledDashboardModal>
      <Typo type="label0" weight="sb" className="text-gray-800">
        {props.title || 'Create dashboard'}
      </Typo>
      <Space h="32px" />

      <Typo type="label2" weight="m" className="text-gray-700">
        {props.label || 'Dashboard name'}
      </Typo>
      <Space h="8px" />
      <Input
        initFocus
        placeholder="example"
        sizeType="l"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setDashboardName(e.currentTarget.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            props.onConfirm(dashboardName);
          }
        }}
        value={dashboardName}
      />
      <Space h="40px" />
      <div className="flex justify-end items-end">
        <Flex a="center" g={12}>
          <Button onClick={closeModal} variant="secondary">
            Cancel
          </Button>

          <Button
            onClick={() => {
              props.onConfirm(dashboardName);
            }}
            disabled={Boolean(
              !dashboardName || (props.value && dashboardName === props.value),
            )}
          >
            {props.buttonLabel || 'Create'}
          </Button>
        </Flex>
      </div>
    </StyledDashboardModal>
  );
};

export default DashboardModal;

const StyledDashboardModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  ${modalStyle};
  width: 600px;
  background-color: ${(props) => props.theme.colors.gray100};
  border-radius: 12px;
  padding: 24px;
  .icon {
    margin-top: 4px;
  }
`;
